import type Alpine from "alpinejs";
import { openDialog, closeDialog } from "../context";

const dialog: Alpine.DirectiveCallback = (_el, _directive, { cleanup }) => {
  openDialog();
  cleanup(() => closeDialog());
};

export default dialog;
